import styled from 'styled-components'

/** 게임 화면 — 머리줄 없이 보이는 화면 전체(주소창이 접히고 펴져도 맞도록 inset 고정) */
export const Wrap = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  background: #000;
`

/** 게임 창 — 테두리 없이 꽉 차게 */
export const GameFrame = styled.iframe`
  display: block;
  width: 100%;
  height: 100%;
  border: none;
  background: #000;
`
